import { IncentiveOfferStatus } from 'modules/incentivesMarket/types';
import { IncentiveOfferDetailContextType } from '../types/IncentiveOfferDetailContextType';

export const incentiveOfferDetailInitValue: IncentiveOfferDetailContextType = {
  data: {
    societyId: '',
    societyName: '',
    offer: null,
    offerStatus: IncentiveOfferStatus.ACTIVE,
    offerReference: '',
    acceptanceHistory: [],
    incentiveOfferOperations: [],
    priceContext: {
      currentOfferPrice: 0,
      lastTransactionPrice: 0,
      avgSellOffersPrice: 0,
      officialValuation: 0,
      userAvgBuyPrice: 0,
    },
    timelineSteps: [],
    sellerInfo: null,
    availableShares: 0,
    totalAvailableUnits: 0,
    offerRemainingUnits: 0,
    sellerPlans: [],
    daysRemaining: 0,
    isAdmin: false,
    isExpired: false,
    isOwnOffer: false,
    userBeneficiaryIds: [],
    beneficiaryQueryParam: '',
    isBeneficiaryView: false,
    viewingBeneficiary: null,
    isLoading: true,
    hasPartnerBuyer: false,
    purchaseQuantity: 1,
    sellPlanSelection: null,
    commissionRate: 0.015,
    eligibles: [],
    eligiblesPage: 1,
    eligiblesRowsPerPage: 10,
    eligiblesTotal: 0,
    eligiblesSearchTerm: '',
    isLoadingEligibles: false,
    isDownloadingEligibles: false,
    operationsPage: 1,
    operationsRowsPerPage: 10,
    operationsTotal: 0,
    operationsSummary: {
      completed: 0,
      pending: 0,
      totalUnits: 0,
      totalAmount: 0,
    },
    isLoadingOperations: false,
    isDownloadingOperations: false,
    hasParticipatedInOffer: false,
    existingBeneficiaryOperation: null,
    isLoadingParticipationCheck: false,
  },
  actions: {
    handleGoBack: () => {},
    handlePurchaseQuantityChange: () => {},
    handleSellUnitsConfirm: () => {},
    handleBuyShares: () => {},
    handleViewOtherOffers: () => {},
    handleGoToOperation: () => {},
    handleOpenGenerateContractModal: () => {},
    handleEligiblesPageChange: () => {},
    handleEligiblesRowsPerPageChange: () => {},
    handleEligiblesSearchChange: () => {},
    handleDownloadEligibles: () => {},
    handleOperationsPageChange: () => {},
    handleOperationsRowsPerPageChange: () => {},
    handleDownloadOperations: () => {},
  },
};
